import connectAsync from '../../utils/connectAsync';
import fetchSubscriptionIfNeeded from '../../actions/connectors/fetchSubscriptionIfNeeded';
import PaymentInformationRoute from './PaymentInformationRoute';

export default connectAsync([fetchSubscriptionIfNeeded])(
  PaymentInformationRoute,
);
